module.exports = __webpack_public_path__ + "static/img/quan02.3d2be73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quan02.png
// module id = pl2F
// module chunks = 0